import { render, staticRenderFns } from "./LearnSoccer.vue?vue&type=template&id=b4f7391c&scoped=true&"
import script from "./LearnSoccer.vue?vue&type=script&lang=js&"
export * from "./LearnSoccer.vue?vue&type=script&lang=js&"
import style0 from "./LearnSoccer.vue?vue&type=style&index=0&id=b4f7391c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f7391c",
  null
  
)

export default component.exports